/**
 * Represents     validate(): any {
        throw new Error("Method not implemented.");
    }
a input handling rules for a state.
 */
export class Input {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
/**
 * Provide validation rules for inputs
 */
export class InputValidation {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
/**
 * Defines the input validation rules to be applied to the user input response message.
 */
export var InputValidationRule;
(function (InputValidationRule) {
    InputValidationRule["Text"] = "text";
    InputValidationRule["Number"] = "number";
    InputValidationRule["Date"] = "date";
    InputValidationRule["Regex"] = "regex";
    InputValidationRule["Type"] = "type";
})(InputValidationRule || (InputValidationRule = {}));
